'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OAuthUtils = require('../../core/utils/OAuthUtils');

var _signupProductIntents = require('../../core/constants/signupProductIntents');

var _signupProductIntents2 = _interopRequireDefault(_signupProductIntents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlowFromSignupIntent = {
  maybeStateFromOAuthPayload: function maybeStateFromOAuthPayload() {
    return (0, _OAuthUtils.parseState)(window.location.hash);
  },
  getMaybeSignupIntentFromPath: function getMaybeSignupIntentFromPath() {
    return window.location.pathname.split('/').slice(2, 3).join('/');
  },
  getSelectedFlow: function getSelectedFlow() {
    var SignupProductIntentsValues = Object.values(_signupProductIntents2.default);

    // normal signups
    var maybeSignupIntentFromPath = this.getMaybeSignupIntentFromPath();

    if (SignupProductIntentsValues.includes(maybeSignupIntentFromPath)) {
      return maybeSignupIntentFromPath;
    }

    // used in the OAuth process
    var state = this.maybeStateFromOAuthPayload();
    var maybeSignupIntentFromOauthPayload = state.signupIntent;

    if (SignupProductIntentsValues.includes(maybeSignupIntentFromOauthPayload)) {
      return maybeSignupIntentFromOauthPayload;
    }

    //can't find the intent from the path, neither from the params returned by google oauth,
    //default to CRM the other scenario of defaulting shouldn't happen anymore
    LOG.warn("Get Selected flow - Couldn't get signup config, defaulting to crm");
    return _signupProductIntents2.default.crm;
  }
};

exports.default = FlowFromSignupIntent;
module.exports = exports['default'];